module.exports = __webpack_public_path__ + "img/search_w.ecc18301.svg";